import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
  faTelescope,
} from '@fortawesome/pro-duotone-svg-icons';
import { Space, SpaceProps } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { FC } from 'react';
import styled from 'styled-components';
import { EmptyStateIcon } from 'components/atoms/empty-state';
import { Caption01 } from 'components/styles';

const MessageContainer = styled.div`
  ${Caption01};
`;

const Message = styled.span`
  ${Caption01};
  padding-right: var(--spacing-02);
`;

const IconContainer = styled.div`
  padding: var(--spacing-03);
`;

type Size = 'small' | 'middle' | 'large';
interface BaseProps extends Pick<SpaceProps, 'direction'> {
  action?: React.ReactNode;
  message?: React.ReactNode;
  size?: SizeType;
  icon: IconProp;
}

const Base: FC<BaseProps> = ({
  action,
  message,
  direction = 'vertical',
  size = 'middle',
  icon,
}) => {
  const iconSize: { [k in Size]: SizeProp } = {
    small: '2x',
    middle: '4x',
    large: '6x',
  };

  return (
    <Space direction={direction} size={16}>
      <IconContainer>
        <EmptyStateIcon size={iconSize[size]} icon={icon} />
      </IconContainer>
      <MessageContainer>
        <Message>{message}</Message>
        {action}
      </MessageContainer>
    </Space>
  );
};

type Props = Omit<BaseProps, 'icon'>;
export const ErrorState: FC<Props> = (props) => (
  <Base {...props} icon={faExclamationTriangle} />
);

export const NoResults: FC<Props> = (props) => (
  <Base {...props} icon={faTelescope} />
);
